<template>
    <div
      :class="itemType + ' class-item ' + classColor"
      @click="onClick(classItem)"
    >
      <div>
        <span
          v-if="editMode"
          @click="showModal()"
          class="forward-button material-icons-round"
          >remove_circle</span
        >
        <span
          v-if="!editMode"
          @click="onClick(classItem)"
          class="forward-button material-icons-round"
          >arrow_forward_ios</span
        >
        <h2 class="class-nickname">
          {{ classItem.classInfo.nickname }}
        </h2>
        <div class="class-grade class-subject">
          {{ classItem.classInfo.grade }}<span v-if="classItem.classInfo.grade != 'Other'">th grade</span>,
          {{ classItem.classInfo.subject }}
        </div>
        <ul id="example-1">
          <li
            v-for="(newDay, idx) in classItem.classInfo.checkedDay"
            :key="idx"
          >
            {{ newDay }}
          </li>
        </ul>
        <div class="class-students">
          <div v-if="!classItem.studentList && classItem.studentCount">
            <i>Tap to add students</i>
          </div>
          <div v-else-if="classItem.studentList">
            {{ classItem.studentList.length }} Student{{
              classItem.studentList.length != 1 ? "s" : ""
            }}
          </div>
        </div>
      </div>
          <Modal v-show="isModalVisible" @close="closeModal">
      <template v-slot:header>
        <b></b>
      </template>
      <template v-slot:body>
        <b>Are you sure you want to delete this class? <br> This action will be permanent.</b>
      </template>
      <template v-slot:footer>
        <div class="modal-button-group">
          <button class="cancel-button" @click="closeModal">Cancel</button>
          <button @click="removeClass(classItem)">Delete Class</button>
        </div>
      </template>
    </Modal>
    </div>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
  name: "ClassItem",
  components: {
    Modal,
  },
  props: ["editMode", "classItem", "itemType"],
  data() {
    return {
      isModalVisible: false,
      deltedState: ''
    };
  },
  computed: {
    classColor() {
      return this.$filters.colorAssign(this.classItem.classId);
    }
  },
  methods: {
    onClick: function (item) {
      if (this.editMode) return;
      this.$store.commit("SET_CURRENT_CLASS", item);
      this.$store.commit("SEND_MESSAGE", {
        data: item.classId,
        opCode: this.$store.state.opCodes.PastSessionsCount,
      });
      if (item.studentList.length == 0) {
        this.$router.push({
          name: "student-list",
          params: { name: item.classInfo.nickname },
        });
      } else {
        this.$router.push({
          name: "class-info",
          params: { name: item.classInfo.nickname },
        });
      }
    },
    removeClass: function (item) {
      this.$store.commit("SEND_MESSAGE", {
        data: item.classId,
        opCode: this.$store.state.opCodes.DeleteClass,
      });
      this.$store.commit("SET_CLASS_REMOVED", true);
      this.isModalVisible = false;
      this.deltedState = "deleted"
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
};
</script>

<style lang="scss">
.modal-backdrop {
  max-width: unset!important;
}
</style>